var site = site || {};

site.device = {};
site.window = {};
site.owl = {};
site.nav = {};
site.sidebar = {};
site.hero = {};
site.extras = {};
site.extras.initDone = false;

site.device.isTouch = function() {
	try {
		document.createEvent("TouchEvent");
		return true;
	} catch (e) {
		return false;
	}
};

site.window.scrollPosition = 0;

// Shorthand to init owlcarousel
site.owl.init = function(id, options) {
	var $owl = $(id);
	if ($owl.length > 0) {
		$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
		$owl.owlCarousel(options);
		return $owl;
	}
};

// Init navigation scripts
site.nav.init = function() {
	// Add expand link to mobile menu
	$('.children', '#mainmenu ').prepend('<a class="expand" href="#"><i class="fa fa-angle-down"></i></a>');
	$('.selectedLevel1','#mainmenu').addClass('down');
	site.nav.appendLanguage();
	site.nav.appendSocial();
	site.nav.bind();
};

// Bind events
site.nav.bind = function() {
	// Mobile menu toggle
	$('#mainmenuToggle').click(function(e) {
		var menuOpen = $('body').hasClass('mainmenu-open');
		if (!menuOpen) {
			site.window.scrollPosition = $(window).scrollTop();
		}
		site.nav.mobileToggle(e, menuOpen, site.window.scrollPosition);
		e.preventDefault();
	});

	// Expand in mobile menu
	$('.expand', '#mainmenu').bind('click', function(e) {
		e.preventDefault();
		var $parent = $(this).parent();
		$parent.toggleClass('down');
	});
};

// Toggle mobile menu
site.nav.mobileToggle = function(e, menuOpen, scrollPosition) {
	$('body').toggleClass('mainmenu-open');
	$(this).toggleClass('open');
	if (!menuOpen) {
		$(window).scrollTop(0);
		$('i', '#mainmenuToggle').removeClass('fa-bars').addClass('fa-close');
	}
	else {
		$(window).scrollTop(scrollPosition);
		$('i', '#mainmenuToggle').removeClass('fa-close').addClass('fa-bars');
	}
};

// Append language to mobilemenu
site.nav.appendLanguage = function() {
	var $divisions = $('#divisions');
	var $menu = $('ul.mmLevel1');

	var $html = $('<li class="ele-language si level1 mobileOnly"></li>');
	$divisions.find('li').each(function() {
		var $li = $(this).clone();
		var $divisionItem = $html.clone().append($li.find('a'));
		$menu.append($divisionItem);
	});
};

site.nav.appendSocial = function() {
	var $fb = $('a.facebook');
	var $menu = $('ul.mmLevel1');
	var $html = $('<li class="ele-social si level1 mobileOnly"></li>');
	$html.append($fb.clone());
	$menu.append($html);
};

/**
 * News
 */
site.news = {
	init: function () {
		if (!$('body').hasClass('news')) return;
		$(window).load(function() {
			var $container = $('#news .entries.all');
			// initialize
			$container.masonry({
				itemSelector: '.entry'
			});
		});
	}
};

/**
 * Extras
 */
site.extras.init = function() {
	$('<select id="extrasMobile" />').insertAfter("#extras .menu.categories");
	$('#extrasMobile').wrap('<div id="extrasMobileWrap"></div>');
	$("#extras .menu.categories li a").each(function() {
		var el = $(this);
		var href = (el.attr("href") == '#') ? '#all' : el.attr("href");
		$("<option />", {
			"value"   : href,
			"text"    : el.text(),
			"class"   : href.substr(1,href.length)
		}).appendTo("#extrasMobile");
	});
	$("#extrasMobile").change(function() {
		var val = $(this).find("option:selected").val();
		location.hash = val;
		val = val.substr(1, val.length);
		$("#extras .menu.categories").find("."+val+" a").trigger('click');
	});

	$(window).load(function() {
		var $container = $('#extras .items');
		$container.isotope({
			// options
			itemSelector: '.item',
			layoutMode: 'vertical',
			hiddenStyle: {
				opacity: 0
			},
			visibleStyle: {
				opacity: 1
			}
		});
	});

	$('.categories').on( 'click', 'a', function(e) {
		if ($(this).parent().hasClass('all')) {
			e.preventDefault();
			site.window.scrollPosition = $(window).scrollTop();
			location.hash = '#';
			$(window).scrollTop(site.window.scrollPosition);
		}
		var filterValue = $(this).attr('data-filter');
		$('#extras .items').isotope({ filter: filterValue });

		$('.categories li').removeClass('selected');
		$(this).parent().addClass('selected');
	});

	$(function() {
		$(window).bind( "hashchange", function(e) {
			var b = location.hash;
			if (b) {
				b = b.substr(1, b.length);
				var $container = $('#extras .items');
				$container.isotope({ filter: '.'+b });
				$('.categories li').removeClass('selected');
				$(".categories ."+b+"").addClass('selected');
				$("#extrasMobile ."+b+"").attr('selected','selected');
			}
		});
		$(window).trigger( "hashchange" );
	});
};
site.extras.upload =  {
	init: function(urls, lang) {
		if(site.extras.initDone === false) {
			site.extras.initDone = true;
			$('ul#images').sortable({
				'opacity': 0.8,
				'update': function (e, ui) {
					var $el = $(this);
					$el.sortable('disable').addClass('disabled');
					$.post(urls.sort, $(this).sortable('serialize'), function (d) {
						if (d.success !== true) {
							moya.message.add(lang.galleryErrorOnSave);
							$el.sortable('cancel');
						}
						$el.removeClass('disabled');
						$el.sortable('enable');
					});
				}
			});
			$('#ffile').uploadify({
				'uploader': '/_moya/js/jquery/uploadify/uploadify.swf',
				'script': urls.script,
				'cancelImg': '/_moya/js/jquery/uploadify/cancel.png',
				'auto': true,
				'multi': true,
				'folder': '/tmp',
				'fileDesc': lang.galleryImageUploadFileDescription,
				'fileExt': '*.jpg;*.jpeg;*.gif;*.png;*.JPG;*.JPEG;*.GIF;*.PNG',
				'buttonText': lang.galleryImageAdd,
				'queueID': 'ffileQueue',
				'onError': function () {
					$('#notice').html('<div class="message"><div class="error">' + lang.galleryErrorOnSave + '</div></div>');
				},
				'onComplete': function (e, q, f, r) {
					var n = $('#notice');
					switch (r) {
						case 'noAlbum':
							n.html('<div class="message"><div class="error">' + lang.galleryErrorNoAlbumName + '</div></div>');
							break;
						case 'noSave':
							n.html('<div class="message"><div class="error">' + lang.galleryErrorOnSave + '</div></div>');
							break;
					}
				},
				'onAllComplete': function () {
					window.location.reload();
				}
			});
		}
	}
};

site.formbuilder = {
	init: function () {
		if($('table.gjafabref').length > 0) {
			site.formbuilder.admin();
		}
		if($('#moya_form_gjafabref').length === 0) return;

		$(window).on('load', function(){
			setTimeout(site.formbuilder.loadFinished, 400);
		});
		site.formbuilder.wrapFormElements();
		site.formbuilder.focusLabels();
		site.formbuilder.cloneCards();
		site.formbuilder.cardStyles();
		site.formbuilder.payment();
		site.formbuilder.receiver();
		site.formbuilder.submit();

		// Fix for 1st option in zipcode select
		$('.elm_postnumer select option:first-of-type').each(function () {
			$(this).text($(this).parents('.elm').find('label').text());
		});
		// change input to number for easier validation and usability
		$('fieldset:nth-of-type(4) .elm_text input').attr('type', 'number');
		$('fieldset:nth-of-type(4) .elm_text input').attr('min', 1000);
		$('fieldset:nth-of-type(4) .elm_text input').attr('max', 100000);


		var href = '/gjafakort/skilmalar';
		$('.elm_multiCheckbox span label:contains("skilmála")').html(function(_, html) {
			return html.replace(/(\bskilmála\b)(?!.*\b\1\b)/, '<a target="_blank" href="' + href + '">$1</a>');
		});

		$('.elm_multiCheckbox span input').click(function (evt) {
			$(this).parent().toggleClass('checked');
		});

		$('form input').each(function () {
			if($(this).is(':checked')) {
				$(this).closest('label').addClass('checked');
			}
		})

	},
	loadFinished: function () {
		$('#moya_form_gjafabref').css('opacity', 1);
	},
	wrapFormElements: function () {
		var first = true;
		$('fieldset').each(function () {
			var divs = $('> div', $(this));
			var wrapSize = first ? 3 : 2;
			$(this).children().wrapAll('<div class="fieldsetWrap"></div>');
			for(var i = 0; i < divs.length; i+=wrapSize) {
				divs.slice(i, i+wrapSize).wrapAll('<div class="wrap"></div>');
			}
			first = false;
		});
	},
	focusLabels: function () {
		var $elms = $('.elm:not(.elm_multiCheckbox) input');
		$elms.focus(function() {
			$(this).closest('.elm').addClass('focus');
			$("label[for='"+this.id+"']").addClass('focusing')
		}).blur(function() {
			if ($(this).val().length < 1) {
				$(this).closest('.elm').removeClass('focus');
				$("label[for='"+this.id+"']").removeClass('focusing')
			}
		});
		$elms.each(function() {
			var $elm = $(this);
			if($elm.val().length > 0) {
				$elm.closest('.elm').addClass('focus');
				$("label[for='"+this.id+"']").addClass('focusing');
			}
		});
	},
	cardStyles: function () {
		$('form input[type="radio"]').click(function () {
			$('form input[type="radio"]').each(function () {
				if($(this).is(':checked')) {
					$(this).parent().addClass('checked');
				}
				else {
					$(this).parent().removeClass('checked');
				}
			});
		});

		$('fieldset:last-of-type .elm_radio span label input').change(function () {
			if($(this).is(':checked') && $(this).parent().is(':last-child')) {
				$(':not(:last-of-type)', $(this).parent().parent()).css('opacity', 0.4);
				$(this).closest('.wrap').children('.elm_text').addClass('active');
				$(this).closest('.wrap').children('.elm_text').addClass('pulsate-fwd');
			}
			else {
				$(':not(:last-of-type)', $(this).parent().parent()).css('opacity', 1);
				$(this).closest('.wrap').children('.elm_text').removeClass('active');
				$(this).closest('.wrap').children('.elm_text').removeClass('pulsate-fwd');
			}
		});
	},
	cloneCards: function () {
		var current = 1;
		$('fieldset:last-of-type button').click(function () {

			var $clonedElements = $('fieldset:last-of-type .wrap:first-of-type').clone();
			$clonedElements.find('[id]').each(function () { $(this).attr('id', $(this).attr('id') + current.toString())});
			$clonedElements.find('[name]').each(function () { $(this).attr('name', $(this).attr('name') + current.toString())});
			$clonedElements.find(':radio').each(function () {
				$(this).prop('checked', false);
				$(this).parent().removeClass('checked');
				$(this).closest('.wrap').children('.elm_text').removeClass('active');

			});
			$clonedElements.append('<button class="close" type="button"></button>');
			$clonedElements.find('label').each(function () {
				$(this).attr('for', $(this).attr('for') + current.toString())
				$(this).css('opacity', '');
			});
			$clonedElements.addClass('slide-in-left');
			$('fieldset:last-of-type .wrap:nth-last-of-type(3)').after($clonedElements);
			current++;
			site.formbuilder.cardStyles();
			site.formbuilder.focusLabels();
			site.formbuilder.payment();
			site.formbuilder.closeButton();
		});
	},

	payment: function () {
		$('.elm_payment').addClass('hide');
		$('.elm_textarea').addClass('hide');

		// afhending
		$('fieldset:nth-of-type(2) .elm_radio input').change(function(){
			var amount = $(this).val();
			var number = amount.match(/\d/g);
			var $payment = $('fieldset:nth-of-type(2) .elm_payment #payment');
			number ? $payment.val(1) : $payment.val(0);
		});
		// kort total
		$('fieldset:nth-of-type(4) .elm_radio input').change(function(){
			$(this).closest('.wrap').children('.elm_text').find('input').val('');
		});
	},
	receiver: function () {
		$('fieldset:nth-of-type(2) .elm_radio input').change(function(){
			var $val = $(this).attr('id');
			if($val.includes('vidtakanda')) {
				$('fieldset:nth-of-type(3)').addClass('slide-in-left');
			}
			else {
				$('fieldset:nth-of-type(3)').removeClass('slide-in-left');
			}

		});
	},
	submit: function () {
		$('#moya_form_gjafabref').submit(function(event) {
			var total = 0;
			var allValues = [];
			$('fieldset:nth-of-type(4) .elm_radio input:checked').each(function (i) {
				var amount = $(this).val();
				var number = amount.match(/\d/g);
				if(number) {
					number = number.join("");
					total = +total + +number;
					allValues.push('Kort nr ' + (i+1) + ': ' +  $(this).val());
				}
				else {
					var customNumber = ($(this).closest('.wrap').children('.elm_text').find('input').val());
					total = +total + +customNumber;
					allValues.push('Kort nr ' + (i+1) + ': ' + customNumber + 'kr.');
				}
			});
			$('fieldset:nth-of-type(4) .elm_payment input:not(.hidden)').val(total);
			$('fieldset:nth-of-type(4) .elm_textarea textarea').val(allValues.join('\n '));
		});
	},
	closeButton: function () {
		$('button.close').on('click', function() {
			$wrap = $(this).closest('.wrap');
			$wrap.addClass('slide-out-left');
			setTimeout(function() {
				$wrap.remove();
			}, 700);
		});
	},
	admin: function () {
		$('table tr td').each(function(){
			if (!$(this).text().trim().length) {
				$(this).parent().addClass("hide");
			}
		});
	},
};

site.frontpage = {
	init: function () {
		var $owl = site.owl.init('#hero > ul', {
			loop: false,
			nav: false,
			autoHeight: true,
			autoplay:true,
			autoplayHoverPause:true,
			autoplaySpeed:5000,
			items: 1,
		});
	},
};

// Run all the inits \o/
$(function() {
	var $body = $('body');
	site.nav.init();
	site.news.init();
	site.formbuilder.init();
	/*
	site.owl.init('#reviews > ul', {
		loop:true,
		nav:true,
		navText:["",""],
		items: 1
	});
	*/

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	$('table', '#center').wrap('<div class="responsiveTable"></div>');

	// Touch login
	$('.login').bind('click', function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	// Reorder language menu based on selected
	// Move is to the top
	$li = $('.selected', '#divisions');
	$ul = $('.menu', '#divisions');
	$ul.prepend($li);

	if ($body.is('.forsida')) {
		site.frontpage.init();
		var monitor = setInterval(function() {
			var elem = document.activeElement;
			if (elem && elem.tagName === 'IFRAME' && $(elem).attr('src').indexOf('youtube') !== -1) {
				clearInterval(monitor);
				$('#tubeOverlay').addClass('clicked');
			}
		}, 100);
	}
});
